import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import * as Track from '@project/shared/utils/tracking/js/tracking';

const classes = {
	countdown: 'js-m-new-event__countdown-time',
	activeDays: 'state-m-new-event__show-days',
	eventDescription: 'js-m-new-event__description',
	eventItem: 'm-new-event__item',
};

@createModule('NewEvent')
/**
 * NewEvent module implementation.
 *
 */
export class NewEvent extends TerrificSpec {
	$ctx: JQuery;

	start(resolve: Function) {
		this.$ctx = $(this._ctx);

		this.initCountdown();
		this.eventDescriptionEllipsis();
		this.onDownLoadCalendar();
		resolve();
	}

	stop() {}

	initCountdown() {
		const $countdown = this.$ctx.find(`.${classes.countdown}`);
		const totalseconds = parseInt($countdown.data('second'));
		if (totalseconds > 86400) {
			$countdown.text(Math.floor(totalseconds / 24 / 3600));
			$countdown.addClass(classes.activeDays);
		} else {
			var me = this;
			setInterval(function() {
				me.calculator();
			}, 1000);
		}
	}

	calculator() {
		const $countdown = this.$ctx.find(`.${classes.countdown}`);
		const totalseconds = parseInt($countdown.data('second'));
		const nextseconds = totalseconds - 1;
		const h =
			Math.floor(nextseconds / 3600) < 10 ? '0' + Math.floor(nextseconds / 3600) : Math.floor(nextseconds / 3600);
		const m =
			Math.floor((nextseconds / 60) % 60) < 10
				? '0' + Math.floor((nextseconds / 60) % 60)
				: Math.floor((nextseconds / 60) % 60);
		const s = Math.floor(nextseconds % 60) < 10 ? '0' + Math.floor(nextseconds % 60) : Math.floor(nextseconds % 60);
		$countdown.data('second', nextseconds);
		$countdown.text(h + ':' + m + ':' + s);
	}

	eventDescriptionEllipsis() {
		const $eventDescription = this.$ctx.find(`.${classes.eventDescription}`);
		if ($eventDescription.text().length > 267) {
			$eventDescription.text($eventDescription.text().substring(0, 267) + '...');
		}
	}

	private onDownLoadCalendar() {
		$(document)
			.off('click')
			.on('click', '.js-a-download', function() {
				var calendarResult = $(this).attr('data-calendarresult');
				if (calendarResult != undefined) {
					if (calendarResult.length > 0) {
						window.open('data:text/calendar;charset=utf8,' + calendarResult);
					} else {
						console.log('calendarResult: calendarResult is empty');
					}
				} else {
					console.log('calendarResult: calendarResult is undefined');
				}
			});
	}
	RegisteredUpdate() {
		const $eventItems = this.$ctx.find(`.${classes.eventItem}`);
		if (Track.isKnownMarketoLead()) {
			$eventItems.each((i, e) => {
				const $event = $(e).children();
				const classList = $event.attr('class');
				const className = classList.split(' ');
				$event.removeClass(className[0] + '--locked');
			});
		}

		if (Track.isKnownCdcLead()) {
			$eventItems.each((i, e) => {
				const $event = $(e).children();
				const classList = $event.attr('class');
				const className = classList.split(' ');
				$event.removeClass(className[0] + '--locked');
			});
		}
	}
}
